const key = (owner: string) => `truxsocial:composer-recovery:${owner}`;
export function readRecovery(owner: string): string | null {
  try {
    const record = JSON.parse(localStorage.getItem(key(owner)) ?? 'null');
    return typeof record?.text === 'string' &&
      record.text.trim() &&
      Date.now() - record.savedAt < 7 * 86400000
      ? record.text.slice(0, 20000)
      : null;
  } catch {
    return null;
  }
}
export function saveRecovery(owner: string, text: string) {
  try {
    if (text.trim())
      localStorage.setItem(
        key(owner),
        JSON.stringify({ text: text.slice(0, 20000), savedAt: Date.now() }),
      );
    else localStorage.removeItem(key(owner));
  } catch {
    /* Recovery is best-effort when storage is full or disabled. */
  }
}
